import { useCallback } from 'react'
import { Org } from '@Interfaces/Data/OrganizationInterface'
import { logout } from '@services/AuthService'
import { UseOrganizationDataReturn } from '@Interfaces/Hooks/DataInterface'

export const useOrganizationData = (
  ourOrgs: Org[],
  selectedOrg: Org | null,
  setSelectedOrg: (org: Org | null) => void
) => {
  const onNotAloud = useCallback(() => {
    if (ourOrgs?.length > 0) {
      // Find org that is not the selected org
      const find = ourOrgs.find((x) => x.id !== selectedOrg?.id)
      if (find) {
        setSelectedOrg(find)
      } else {
        logout()
      }
    }
  }, [ourOrgs, selectedOrg, setSelectedOrg])

  return {
    onNotAloud,
  }
}
